export const getFilteredModifiers = ({ searchTerm, modifiers }) => {
  const searchTerms = searchTerm?.split(' ').filter((s) => s);
  if (!searchTerm || !searchTerms.length) {
    return modifiers;
  }
  const filteredModifiers = JSON.parse(JSON.stringify(modifiers))
    .filter(({ name, title }) => (name || title || '').toLowerCase().includes(searchTerm));
  if (filteredModifiers.length > 0) return filteredModifiers;

  return JSON.parse(JSON.stringify(modifiers))
    .filter(({ name }) => searchTerms.some((term) => name.toLowerCase().includes(term)));
};

export const getNormalizedFilteredModifiers = ({ searchTerm, modifiers, excludeNested }) => getFilteredModifiers({ searchTerm, modifiers })
  // .filter((m) => (excludeNested ? m.options_parents?.length === 0 : true))
  .map((mod) => ({
    key: mod.id,
    id: mod.id,
    value: mod.name,
    name: mod.name,
    modifiers_children: mod.options,
  }));
